<script>
// import { getSubscribersList } from "@/api/subscribers";
import {
  getSegments,
  getTemplates,
  addCampaign,
  sendCampaign,
  sendTestEmail
} from "@/api/campaigns";
import { getEmailSenders } from "@/api/accounts";
import swal from "sweetalert";
export default {
  name: "add-campaigns-modal",
  data() {
    return {
      form: {
        name: "",
        subject: "",
        subscriber_list_id: null,
        template_id: null,
        sender_name: "",
        sender_email: "",
        personalization: null,
        segment_id: null
      },
      subscribersLists: [],
      segments: [],
      templates: [],
      personalizationOptions: [
        { value: null, text: "Insert Personalization" },
        { value: "name", text: "Name" }
      ],
      disabled: false,
      btnTxt: "Add Campaign",
      btnTxtSend: "Send Campaign",
      emails: [],
      snackbar: false,
      text: "",
      timeout: 2000,
      test_email: null,
      process: null,
      sending_test_email: false
    };
  },
  async mounted() {
    let response = null;
    //Fetch segments
    response = await getSegments();
    if (response && response.length > 0) {
      this.segments = response;
    } else {
      this.snackbar = true;
      this.text = "Fetching of segment list. Returns empty response";
    }
    // Fetch subscribers list
    // response = await getSubscribersList();
    // if (response && response.length > 0) {
    //   this.subscribersLists = response;
    // } else {
    //   this.snackbar = true;
    //   this.text = "Fetching of subscribers list. Returns empty response";
    // }
    // Fetch templates
    response = await getTemplates();
    if (response && response.length > 0) {
      this.templates = response;
    } else {
      this.snackbar = true;
      this.text = "Fetching of templates. Returns empty response";
    }
    // Fetch email senders
    response = await getEmailSenders();
    if (response && response.length > 0) {
      this.emails = response;
    } else {
      this.snackbar = true;
      this.text = "Fetching of templates. Returns empty response";
    }
  },
  computed: {
    segmentsOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.segments.map(list => {
          return {
            value: list.id,
            text: list.name
          };
        })
      ];
    },
    subscribersOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.subscribersLists.map(list => {
          return {
            value: list.id,
            text: list.name
          };
        })
      ];
    },
    templatesOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.templates.map(list => {
          return {
            value: list.id,
            text: list.name
          };
        })
      ];
    },
    emailOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.emails.map(list => {
          return {
            value: list.id,
            text: `${list.email}`
          };
        })
      ];
    }
  },
  methods: {
    addTemplate() {
      this.$router.push(`/templates`);
    },
    send_test() {
      this.process = "send_test";
      document.getElementById("test_email").required = true;
      document.getElementById("select-segment_list_id").required = false;
    },
    send_campaign() {
      this.process = "send_campaign";
      document.getElementById("test_email").required = false;
      document.getElementById("select-segment_list_id").required = true;
    },
    add_campaign() {
      this.process = "add_campaign";
      document.getElementById("test_email").required = false;
      document.getElementById("select-segment_list_id").required = true;
    },
    async onSubmit() {
      console.log(this.process);
      if (this.process === "send_test") {
        this.sendTestEmail();
      }
      if (this.process === "add_campaign") {
        this.addCampaign();
      }
      if (this.process === "send_campaign") {
        this.sendCampaign();
      }
      // console.log(this.form);
    },
    async addCampaign() {
      this.disabled = true;
      this.btnTxt = "Adding ...";
      const payload = JSON.parse(
        JSON.stringify({
          name: this.form.name,
          subject: this.form.subject,
          subscriber_list_id: this.form.subscriber_list_id,
          subscriber_list: this.form.subscriber_list_id,
          segment_id: this.form.segment_id,
          template_id: this.form.template_id,
          sender_name: this.form.sender_name,
          sender_email: this.form.sender_email,
          personalization: this.form.personalization
        })
      );
      const response = await addCampaign(payload);
      if (response) {
        swal("Campaign added.");
        setTimeout(() => {
          document.getElementById("mainForm-addCampaign").reset();
          this.disabled = false;
          this.btnTxt = "Add Campaign";
          this.$refs["modal-add-campaign"].hide();
          this.$store.dispatch("getCampaignList");
        }, 2000);
      } else {
        this.disabled = false;
        this.btnTxt = "Add Campaign";
        swal("There's an issue", "Error in creating a campaign");
      }
    },
    async sendCampaign() {
      this.disabled = true;
      this.btnTxtSend = "Sending ...";
      const payload = JSON.parse(
        JSON.stringify({
          name: this.form.name,
          subject: this.form.subject,
          subscriber_list_id: this.form.subscriber_list_id,
          subscriber_list: this.form.subscriber_list_id,
          segment_id: this.form.segment_id,
          template_id: this.form.template_id,
          sender_name: this.form.sender_name,
          sender_email: this.form.sender_email,
          personalization: this.form.personalization,
          status: "sending"
        })
      );
      const response = await addCampaign(payload);
      if (response && response.success) {
        const send = await sendCampaign(response.campaign_id);
        if (send) {
          swal("Campaign sent");
          this.$store.dispatch("getCampaigns");
        } else {
          swal("There's an issue", "Error in sending campaign");
        }
      } else {
        swal("There's an issue", "Error in sending campaign");
      }
      document.getElementById("mainForm-addCampaign").reset();
      this.disabled = false;
      this.btnTxtSend = "Send Campaign";
      this.$refs["modal-add-campaign"].hide();
    },
    onChange() {
      if (this.form.personalization) {
        let el = document.getElementById("input-subject");
        let val = el.value;
        let position = val.slice(0, el.selectionStart).length;
        let output = [
          val.slice(0, position),
          "{NAME}",
          val.slice(position)
        ].join("");
        this.form.subject = output;
      } else {
        let tempStr = this.form.subject;
        let str = tempStr.replace("{NAME}", "");
        this.form.subject = str;
      }
    },
    create_segment() {
      this.$router.push("/segments");
    },
    async sendTestEmail() {
      this.sending_test_email = true;
      const payload = JSON.parse(
        JSON.stringify({
          name: this.form.name,
          subject: this.form.subject,
          template_id: this.form.template_id,
          email: this.test_email
        })
      );
      // console.log("payload", payload);
      const response = await sendTestEmail(payload);
      // console.log(response);
      if (response && response.message) {
        swal("Test email sent");
        this.sending_test_email = false;
      } else {
        this.sending_test_email = false;
        swal("There's an issue", "Error in sending test email");
      }
    }
  }
};
</script>

<template>
  <b-modal
    id="modal-add-campaign"
    ref="modal-add-campaign"
    title="Create Email Campaign"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
  >
    <b-form
      v-on:submit.prevent="onSubmit"
      method="POST"
      accept-charset="UTF-8"
      enctype="multipart/form-data"
      id="mainForm-addCampaign"
    >
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-template"
            label="Template:"
            label-for="select-template"
          >
            <b-form-select
              id="select-template"
              v-model="form.template_id"
              :options="templatesOptions"
              required
            ></b-form-select>
            <b-form-text>
              <a href="#" @click.prevent="addTemplate">Add Template</a>
            </b-form-text>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-campaign-name"
            label="Campaign Name:"
            label-for="input-campaign-name"
          >
            <b-form-input
              id="input-campaign-name"
              v-model="form.name"
              type="text"
              required
              placeholder="Campaign name"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-from-name"
            label="Who is it from:"
            label-for="input-from-name"
          >
            <b-form-input
              id="input-from-name"
              v-model="form.sender_name"
              type="text"
              required
              placeholder="Who is it from"
            ></b-form-input>
            <b-form-text id="input-from-name-help">
              This will be displayed in the From field of your recipient's email
              client.
            </b-form-text>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-from-email"
            label="From Email:"
            label-for="input-from-email"
          >
            <!-- <b-form-input
              id="input-from-email"
              v-model="form.sender_email"
              type="text"
              required
              placeholder="From email"
            ></b-form-input> -->
            <b-form-select
              id="input-from-email"
              v-model="form.sender_email"
              :options="emailOptions"
              required
            ></b-form-select>
            <b-form-text id="input-from-name-help">
              We recommend using your own email and name. Avoid emails like
              no-reply@company.com.
            </b-form-text>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group label="Send Test Email">
        <b-input-group>
          <b-form-input id="test_email" v-model="test_email"></b-form-input>
          <b-input-group-append>
            <b-button
              size="sm"
              text="Button"
              variant="success"
              @click="send_test"
              type="submit"
              v-if="!sending_test_email"
              >Send</b-button
            >
            <b-button v-if="sending_test_email" variant="primary" disabled>
              <b-spinner small></b-spinner>
              <span class="sr-only">Loading...</span>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-text>
          Insert an email address to receive a test campaign
        </b-form-text>
      </b-form-group>
      <b-form-group
        id="input-group-subject"
        label="Subject"
        label-for="input-subject"
      >
        <b-row>
          <b-col>
            <div>
              <b-input-group>
                <b-form-input
                  id="input-subject"
                  v-model="form.subject"
                  type="text"
                  required
                  placeholder="Subject"
                ></b-form-input>
                <template #append>
                  <b-form-select
                    id="select-personalization"
                    v-model="form.personalization"
                    :options="personalizationOptions"
                    class="bg-secondary"
                    @change="onChange($event)"
                  ></b-form-select>
                </template>
              </b-input-group>
            </div>
          </b-col>
        </b-row>
      </b-form-group>
      <div class="text-right">
        <a href="#" @click.prevent="create_segment()">Create Segment</a>
      </div>
      <b-form-group
        id="input-group-segment-list"
        label="Segments:"
        label-for="select-segment_list_id"
      >
        <b-form-select
          id="select-segment_list_id"
          v-model="form.segment_id"
          :options="segmentsOptions"
          required
        ></b-form-select>
      </b-form-group>
      <b-form-group class="campaign-btn-cont">
        <b-button
          type="submit"
          class="btn-success float-right campaign-btns"
          :disabled="disabled"
          variant="primary"
          @click="send_campaign"
        >
          {{ btnTxtSend }}
        </b-button>
        <b-button
          type="submit"
          class="float-right campaign-btns"
          :disabled="disabled"
          variant="primary"
          @click="add_campaign"
        >
          {{ btnTxt }}
        </b-button>
      </b-form-group>
    </b-form>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </b-modal>
</template>

<style scoped>
.campaign-btn-cont {
  margin: 10px;
  width: 100%;
}
.campaign-btns {
  margin: 10px;
}
</style>
